import React from 'react';
import './AddButton.css';
import '../../common/CommonText.css'
import '../../common/style.css'

const AddButton = ({ onClick }) => {
  return (
      <button className='add-blue-button common-text fts-15 ftw-4 white' onClick={onClick}>
        + New
      </button>
  );
};

export default AddButton;
